export var SECONDS_IN_MINUTE = 60;
export var MINUTES_IN_HOUR = 60;
export var DAYS_IN_WEEK = 7;
export var MILLISECONDS_IN_SECOND = 1000;
export var MILLISECONDS_IN_MINUTE = SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
export var MILLISECONDS_IN_HOUR = MINUTES_IN_HOUR * MILLISECONDS_IN_MINUTE;
export var MILLISECONDS_IN_DAY = SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
export var MILLISECONDS_IN_WEEK = DAYS_IN_WEEK * MILLISECONDS_IN_DAY;
/**
 * utility to determine amount of milliseconds
 * by seconds, minutes, days, etc.
 */
export var milliseconds = {
    inSeconds: function inSeconds(amount) {
        return amount * MILLISECONDS_IN_SECOND;
    },
    inMinutes: function inMinutes(amount) {
        return amount * MILLISECONDS_IN_MINUTE;
    },
    inDays: function inDays(amount) {
        return amount * MILLISECONDS_IN_DAY;
    },
    inWeeks: function inWeeks(amount) {
        return amount * MILLISECONDS_IN_WEEK;
    }
};
